import usuarioUtil from '@/util/usuarioUtil'
import UploadFile from '@/components/layout/uploadFile/UploadFile.vue'
import imageStreamUtil from '@/components/layout/imageStream/js/util'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { BToast } from 'bootstrap-vue'
import uploadImagem from './mixin/uploadImagem'
import CustomBackgroundWrapper from '../CustomBackgroundWrapper.vue'

export default {
  name: 'uploadAvatar',
  props: {
    uploadFileRef: String,
    disabled: Boolean,
    codigoFotoUsuario: Object
  },
  components: {
    UploadFile,
    CustomBackgroundWrapper,
    Cropper,
    'b-toast': BToast
  },
  mixins: [uploadImagem],
  computed: {
    usuarioNaoTemFoto () {
      return (!usuarioUtil.usuarioTemFoto(this.codigoFotoUsuario))
    },
    exibirImagemSemFoto () {
      const usuarioTemFoto = usuarioUtil.usuarioTemFoto(this.codigoFotoUsuario)
      const temArquivoSelecionado = this.arquivoSelecionado !== null

      return (!usuarioTemFoto && !temArquivoSelecionado)
    },
    exibirFoto () {
      const usuarioTemFoto = usuarioUtil.usuarioTemFoto(this.codigoFotoUsuario)
      const temArquivoSelecionado = this.arquivoSelecionado !== null

      return (usuarioTemFoto || temArquivoSelecionado)
    },
    fotoParaPrevisao () {
      const temArquivoSelecionado = this.arquivoSelecionado !== null
      const usuarioTemFoto = usuarioUtil.usuarioTemFoto(this.codigoFotoUsuario)
      if (temArquivoSelecionado) {
        return URL.createObjectURL(this.arquivoSelecionado)
      } else if (!temArquivoSelecionado && usuarioTemFoto) {
        return imageStreamUtil.obterEnderecoImagem(this.codigoFotoUsuario)
      }
      return require('@/assets/img/usuario-sem-foto.png')
    }
  },
  data: () => {
    return {
      cropperRef: 'avatarCropper',
      backgroundColor: 'white'
    }
  },
  methods: {
    aplicarAjustesNaImagem () {
      const { canvas } = this.$refs.avatarCropper.getResult()
      const context = canvas.getContext('2d')
      context.globalCompositeOperation = 'destination-over'
      context.fillStyle = this.backgroundColor
      context.fillRect(0, 0, canvas.width, canvas.height)
      canvas.toBlob(result => {
        this.updateValue(result)
      }, 'image/png')
    }
  }
}
